<template>
    <div>
        <form @submit.prevent class="m-form" name="otherFutureLosses">
            <div class="flex-grid a-form-inputs">
                <div class="flex-grid__item--third">
                    <div class="u-margin-bottom-20 u-bold">
                        Are there any other future losses?
                    </div>
                    <control for="future_losses"
                             :table-control="true">
                        <select id="future_losses"
                                v-model="hasOtherFutureLosses"
                                v-field-control
                                required>
                            <option :value="null" disabled hidden>Please select...</option>
                            <option :value="true">Yes</option>
                            <option :value="false">No</option>
                        </select>
                    </control>
                </div>
            </div>

            <div v-if="hasOtherFutureLosses">

                <future-pension class="u-margin-bottom-40"></future-pension>

                <hr>

                <future-care></future-care>

                <hr>

                <future-services></future-services>

                <hr>

                <future-purchases></future-purchases>

            </div>

        </form>
        
        <step-button :next-valid="isValid"></step-button>
    </div>
</template>
<script>
    import Control from 'components/form/Control.vue';
    import ControlError from 'components/form/control/Error.vue';
    import FormValidator from 'components/form/validator/mixin';
    import StepButton from 'components/StepButton.vue';
    import {setStepValid} from 'services/routingMethods';
    import {mapActions, mapGetters} from 'vuex';
    import FuturePension from 'pages/personal-injury-claims/steps/other-future-losses/FuturePension.vue';
    import FutureCare from 'pages/personal-injury-claims/steps/other-future-losses/FutureCare.vue';
    import FutureServices from 'pages/personal-injury-claims/steps/other-future-losses/FutureServices.vue';
    import FuturePurchases from 'pages/personal-injury-claims/steps/other-future-losses/FuturePurchases.vue';

    export default {
        name: 'other-future-losses',
        mounted() {
            this.isValid
        },
        mixins: [
            FormValidator
        ],
        components: {
            Control,
            ControlError,
            StepButton,
            FutureCare,
            FutureServices,
            FuturePurchases,
            FuturePension,
        },
        computed: {
            ...mapGetters('personal/otherFutureLosses', [
                'value',
                'pensionValid',
                'careValid',
                'servicesValue',
                'servicesValid',
                'purchasesValid'
            ]),
            ...mapGetters('personal/claimant', [
                'claimant',
                'getClaimInfo',
                'getClaimantValue'
            ]),
            hasOtherFutureLosses: {
                get() {
                    return this.value('hasOtherFutureLosses');
                },
                set(value) {
                    this.set({key: 'hasOtherFutureLosses', value});
                }
            },
            isValid() {
                if (this.hasOtherFutureLosses === false) {
                    return true
                }

                if (this.hasOtherFutureLosses) {
                    return (
                         this.careValid
                     && this.servicesValid
                     && this.purchasesValid
                     && this.pensionValid
                    );
                }

                return false;
            },
        },
        watch: {
            ['isValid'] () {
                this.updateValid()
            },
            ['pensionValid'] () {
                this.updateValid()
            },
            ['careValid'] () {
                this.updateValid()
            },
            ['servicesValid'] () {
                this.updateValid()
            },
            ['purchasesValid'] () {
                this.updateValid()
            },
        },
        methods: {
            ...mapActions('personal/otherFutureLosses', ['set', 'updateCare', 'setServices', 'updateServices']),
            updateValid() {
                setStepValid(this.isValid);
            },
        }
    }
</script>



// WEBPACK FOOTER //
// OtherFutureLosses.vue?044e879c